module.exports = __webpack_public_path__ + "intuit-card-top-right.1MVdMQlY.png";